import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  HostListener,
  ElementRef,
  NgZone,
  ChangeDetectorRef
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {debounceTime, first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {Sort, MatSortModule} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {PatientService} from '../../Services/patient.service';
import {InsuranceService} from '../../Services/insurance.service';
import {HttpResponse} from '@angular/common/http';
import * as $ from 'jquery';
import {Subject} from 'rxjs';
import {isValid, format, parse} from 'date-fns';
import {isDateLike, formatDateString} from '../../Model/utils';
import {DatePipe} from "@angular/common";

interface userWorkListPage {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

@Component({
  selector: 'pm-user-work-list',
  templateUrl: './user-work-list.component.html',
  styleUrls: ['./user-work-list.component.css']
})

export class UserWorkListComponent implements OnInit {

  tableData: any = [];
  sortedData: any[]=[];
  sortField: string;
  sortDirection: 'asc' | 'desc' | null = null;
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  pagination: userWorkListPage = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };

  totalPagesArray: any[] = [];
  totalRecord: any;
  searchText: any;
  searchString: any = null;
  selectedType: number = 2;
  selectedStatusFilter: 'all' | 'active' | 'inactive' = 'active';
  selectedPatientBenefitType: 'DENTAL' | 'MEDICAL' | 'BOTH' = 'BOTH';
  showDateFilter = false;
  startDate: Date;
  endDate: Date;
  todaysDate: Date = new Date();
  tStartDate: Date = new Date();
  tEndDate: Date = new Date();
  ignoreDocumentClick = false;
  lastUsedFilterParams: any = {};
  checked: boolean = false;
  patientIds: any = [];
  isSearchMode = false;
  private clientSub: any;
  private lastSearchParams: any = null;   // for searchPatient API
  private lastFetchParams: any = null;    // optional, for _fetchData API
  private subject: Subject<string> = new Subject();
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild('searchBox') searchValue!: ElementRef;
  @ViewChild('filterDropdown') filterDropdown: ElementRef;
  @ViewChild('filterBtn') filterBtn: ElementRef;

  constructor(private fb: FormBuilder,
              private patientServices: PatientService,
              private insuranceServices: InsuranceService,
              private authService: AuthService,
              private router : Router,
              private datePipe: DatePipe,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {
    this._setSearchSubscription()
  }


    ngOnInit(): void {
        // Retrieve the last visited page from session storage
        const savedFilters = sessionStorage.getItem('lastUsedFilterParams');
        if (savedFilters) {
            try {
              this.lastUsedFilterParams = JSON.parse(savedFilters) || {};
              const benefit = this.lastUsedFilterParams.patientBenefitType;
              this.selectedPatientBenefitType =
                benefit === 'DENTAL' || benefit === 'MEDICAL' ? benefit : 'BOTH';
              const start = this.lastUsedFilterParams.startDate;
              const end = this.lastUsedFilterParams.endDate;
              this.startDate = start ? new Date(start) : null;
              this.endDate = end ? new Date(end) : null;
            } catch (error) {
              this.lastUsedFilterParams = {};
              sessionStorage.removeItem('lastUsedFilterParams');
            }
        }
        this.loadPaginationState();
        this.calculateTotalPages();// Remove pagination state on reload
        this._fetchData();

        this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
          if (clientId) {
            this.pagination.page = 1;
            this.pagination.currentPage = 0;
            this.lastUsedFilterParams = {};
            this.selectedPatientBenefitType = 'BOTH';
            sessionStorage.removeItem('lastUsedFilterParams');
            this._fetchData();
          }
        });
        // this.sortedData = [...this.tableData];
        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('userWorkListPage');
        });

        localStorage.setItem('patientIds', JSON.stringify(this.patientIds));

        this.router.navigate(['userworkarea/'], { state: { from: this.router.url } });
  }

    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }

    ngAfterViewInit() {
    /*  if (this.paginator) {
        this.paginator.pageIndex = this.currentPage - 1;  // Assign paginator to data source
        this.tableData.paginator = this.paginator;

        // Initialize Bootstrap popovers globally
        ($('[data-toggle="popover"]') as any).popover();
      }*/
      if (this.paginator) {
        this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
        ($('[data-toggle="popover"]') as any).popover();
      }
    }

  formatStartOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }

  formatEndOfDay(date: Date | string | null): string | null {
    if (!date) {
      return null;
    }

    const dateObj = new Date(date);
    dateObj.setHours(23, 59, 59, 999);
    return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
  }


  onKeyUp(event: any): void {
    const searchTextValue = event.target.value.trim();
    this.subject.next(searchTextValue);

    if (searchTextValue === '') {
      this.searchString = '';  // Reset searchString
      this.pagination.currentPage = 0;   // Ensure page is reset
      this._fetchData();  // Fetch full listing
    }
  }


  private _setSearchSubscription(): void {
    this.subject.pipe(
        debounceTime(300)
    ).subscribe((searchValue: any) => {
      if (searchValue.trim() === '') {
        this.searchString = '';  // Reset searchString
        this.pagination.currentPage = 1;  // Reset page index before fetching
        this._fetchData(1);  // Fetch full listing
      } else {
        this.searchString = searchValue;  // Set new search value
        this.searchPatient();  // Perform search
      }
    });
  }

  onSearch() {
    let inputValue = this.searchValue.nativeElement.value.trim(); // Trim to remove extra spaces

    if (!inputValue) {
      // If input is empty, reset searchString and fetch full listing
      this.searchString = '';
      /*this.pagination.currentPage = 1; */ // Reset page index before fetching
      this._fetchData(1);  // Fetch full data
      return;
    }

    // Decode any URL-encoded characters like %20 to a normal string
    inputValue = decodeURIComponent(inputValue);

    // Use a regular expression to determine if the input looks like a date
    // const isDateLike = this.isDateLike(inputValue);

    if (isDateLike(inputValue)) {
      const formattedDate = formatDateString(inputValue);
      if (formattedDate) {
        this.searchString = formattedDate;
        this.searchPatient();
      }
    } else {
      this.searchString = inputValue;
      this.searchPatient();
    }
  }

  handleKeyUp(event: KeyboardEvent) {
    // const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onSearch();
      return;
    }

    // Existing debounce logic
    // this.subject.next(value);
  }
  onSearchInput(value: string): void {
  // Only reload when the user completely clears the input
  if (!value.trim()) {
    this.searchString = '';
    this._fetchData();
  }
}
  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.searchString = '';
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this._fetchData();
  }

  setFilterType(
    type: 'all' | 'active' | 'inactive'
  ): void {

    this.selectedStatusFilter = type;

    if (type === 'active') {

      this.selectedType = 2;

    } else if (type === 'inactive') {

      this.selectedType = 3;

    } else {

      this.selectedType = 1;

    }
  }

  formatDateString(inputDate: string) {
    // Define possible date formats to parse the input date
    const formats = [
      'MM/dd/yyyy',
      'dd/MM/yyyy',
      'yyyy/MM/dd',
      'yyyy-MM-dd',
      'dd-MM-yyyy',
      'MM-dd-yyyy',
      'MMMM dd, yyyy',    // e.g., "October 15, 2024"
      'yyyy/MM/dd HH:mm',  // e.g., "2024/10/15 14:30"
      'MM/dd/yyyy HH:mm',  // e.g., "10/15/2024 14:30"
      'dd-MM-yyyy HH:mm',  // e.g., "15-10-2024 14:30"
    ];

    let parsedDate: Date | null = null;

    // Try parsing the input date with each format
    for (const formatStr of formats) {
      parsedDate = parse(inputDate, formatStr, new Date());
      if (isValid(parsedDate)) {
        break;  // Stop if a valid date is found
      }
    }

    // If a valid date was parsed, format it to 'MM/dd/yyyy'
    if (parsedDate && isValid(parsedDate)) {
      const formattedDate = format(parsedDate, 'MM/dd/yyyy');
      this.searchString = formattedDate; // Set the formatted date as the search string

      // Call the search function with the formatted date
      this.searchPatient();
    }
    // If no valid date is found, simply do nothing (no error message shown)
  }

  private updateTable(response: any) {
    this.ngZone.run(() => {
      this.tableData = [...(response?.content || response || [])];
      this.totalRecord = response?.totalElements || 0;
      this.totalPagesArray = Array.from(
        { length: response?.totalPages || 0 },
        (_, i) => i + 1
      );

      if (this.paginator) {
        this.paginator.pageIndex = this.pagination.currentPage;
      }

      this.cdr.detectChanges();
    });
  }

  searchPatient() {
    this.isSearchMode = !!(this.searchString && this.searchString.trim());

    // reset to first page for a new search
    this.pagination.currentPage = 0;
    this.pagination.page = 1;

    sessionStorage.setItem('userWorkListPage', JSON.stringify(this.pagination));

    if (!this.isSearchMode) {
      // if search cleared, go back to normal listing
      this._fetchData();
      return;
    }

    const search: any = {
      page: this.pagination.page,
      size: this.pagination.size,
      searchString: this.searchString,
      clientId: this.authService?.getClientId() ? this.authService.getClientId() : 1,
      patientBenefitType: this.selectedPatientBenefitType,
      duplicate: false
    };

    if (this.sortField && this.sortDirection) {
      search.sort = `${this.sortField},${this.sortDirection}`;
    }

    this.lastSearchParams = { ...search };

    this.patientServices.searchPatient(search).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.updateTable(response);
        }
      },
      (error) => {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message || 'something went wrong !',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  private loadTable(type?: any) {
    if (this.isSearchMode) {
      this.searchPatientPage();
    } else {
      this._fetchData(type);
    }
  }

  private searchPatientPage() {
    if (!this.lastSearchParams) {
      // fallback if something went wrong
      this.searchPatient();
      return;
    }

    const params = {
      ...this.lastSearchParams,
      page: this.pagination.page,
      size: this.pagination.size,
      patientBenefitType: this.selectedPatientBenefitType,
    };

    if (this.sortField && this.sortDirection) {
      params.sort = `${this.sortField},${this.sortDirection}`;
    }

    this.lastSearchParams = { ...params };

    this.patientServices.searchPatient(params).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.tableData = response.content;
          this.totalRecord = response?.totalElements;
          this.totalPagesArray = Array.from({ length: response?.totalPages }, (_, i) => i + 1);
          if (this.paginator) this.paginator.pageIndex = this.pagination.currentPage;
        }
      },
      (error) => {
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message || 'something went wrong !',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  pageChange(event: any) {
    this.pagination.currentPage = event.pageIndex;
    this.pagination.page = this.pagination.currentPage + 1;
    this.pagination.size = event.pageSize;

    sessionStorage.setItem('userWorkListPage', JSON.stringify(this.pagination));

    this.loadTable();
  }

// Handles page jump from the dropdown
  jumpToPage(event: any) {
    this.pagination.currentPage = event.value;
    this.pagination.page = this.pagination.currentPage + 1;

    sessionStorage.setItem('userWorkListPage', JSON.stringify(this.pagination));

    this.loadTable(1);
  }

// Calculate total pages and update dropdown options
  calculateTotalPages() {
    const totalPages = Math.ceil(this.totalRecord / this.pagination.size);
    this.totalPagesArray = Array.from({ length: totalPages }, (_, i) => i + 1);
  }

// Load pagination state from session storage
  loadPaginationState() {
    const storedData = sessionStorage.getItem('userWorkListPage');

    if (storedData) {
      this.pagination = JSON.parse(storedData);
      this.calculateTotalPages();
    }
  }

  showPopover(button: HTMLElement) {
    ($(button) as any).popover('show');
  }

  hidePopover(button: HTMLElement) {
    ($(button) as any).popover('hide');
  }

  exportData(format: string, patientId: string, filename: string) {
    // Export is available only after the patient is verified.
    const patient = this.tableData.find(item => String(item.id) === String(patientId));
    if (!patient || patient.verification !== 'VERIFIED') {
      return;
    }

    const params = {
      patientId: patientId,
      format: format,
      clientId: this.authService.getClientId()
    };
    this.insuranceServices.getExportFile(null, params).subscribe(
      (response: HttpResponse<Blob>) => {
        try {
          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = 'patient.xlsx';
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/);
            if (match) {
              filename = decodeURIComponent(match[1] || match[2]);
            }
          }

          const blob = new Blob([response.body!], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          const downloadURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(downloadURL);

          swal.fire({
            icon: 'success',
            title: 'Download Successful',
            text: `The file "${filename}" has been downloaded successfully.`,
            timer: 3000,
            timerProgressBar: true
          });
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: 'An unexpected error occurred while processing the file.',
          });
        }
      },
      (error) => {
        swal.fire({
          icon: 'error',
          title: 'Download Failed',
          text: error?.message || 'Unable to download the file. Please try again later.',
        });
      }
    );
  }

  assign(id?: any) {
    if (id === 'All') {
      if (this.checked) {
        // Uncheck all items
        this.patientIds = []; // Clear assignArray
        this.tableData.forEach(item => {
          item.assigned = false; // Set assigned to false for all
          delete item.assignedF; // Remove the assignedF property
        });
        this.checked = false;
      } else {
        // Assign all items
        this.patientIds = this.tableData.map(item => item.id); // Update assignArray with all IDs
        this.tableData.forEach(item => {
          item.assigned = true; // Set assigned to true for all
          item.assignedF = true; // Add assignedF property
        });
        this.checked = true;
      }
      localStorage.setItem('patientIds', JSON.stringify(this.patientIds));
    } else {
      const index = this.patientIds.indexOf(id);
      if (index === -1) {
        // Add ID if it's not in assignArray and set assigned to true
        this.patientIds.push(id);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = true;
          item.assignedF = true; // Add assignedF property to the specific item
        }
      } else {
        // Remove ID if it's already in assignArray
        this.patientIds.splice(index, 1);
        const item = this.tableData.find(item => item.id === id);
        if (item) {
          item.assigned = false;
          delete item.assignedF; // Remove the assignedF property from the specific item
        }
      }

      // Set checked to true only if all tableData IDs are in assignArray
      this.checked = this.tableData.every(item => this.patientIds.includes(item.id));
      localStorage.setItem('patientIds', JSON.stringify(this.patientIds));
    }
  }

  bulkExport() {
    if (!this.patientIds || this.patientIds.length === 0) { return; }

    const params = {
      clientId: this.authService.getClientId(),
      patientIds: this.patientIds,
      format: 'excel',
      clientName: null,
      officeId: null,
    };

    this.insuranceServices.getBulkExport(params).subscribe({
      next: (response: HttpResponse<Blob>) => {
        try {
          if (!response.body) {
            throw new Error('Empty file received');
          }

          // Try filename from Content-Disposition; otherwise fallback
          const dispo = response.headers.get('content-disposition') || '';
          const match = /filename\*?=(?:UTF-8'')?["']?([^\"';]+)["']?/i.exec(dispo);
          const fallback = `bulk-export-${new Date().toISOString().slice(0,10)}.xlsx`;
          const fileName = match ? decodeURIComponent(match[1]) : fallback;

          // Respect server mime if present
          const contentType = response.headers.get('content-type') ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = new Blob([response.body], { type: contentType });

          this.saveBlobToFile(blob, fileName);

          swal.fire({
            icon: 'success',
            title: 'Download Successful',
            text: `The file "${fileName}" has been downloaded successfully.`,
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: error?.message || 'An unexpected error occurred while processing the file.',
          });
        }
      },
      error: (error) => {
        swal.fire({
          icon: 'error',
          title: 'Download Failed',
          text: error?.error?.message || error?.message || 'Unable to download the file. Please try again later.',
        });
      }
    });
  }

  private saveBlobToFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  // Get Client data
  _fetchData(type?: any) {

        let params: { [key: string]: any } = {
            page : this.pagination.page,
            size: this.pagination.size,
            clientId: this.authService.getClientId() ? this.authService.getClientId() : null,
            startDate:  this.formatStartOfDay(this.tStartDate),
            endDate:  this.formatEndOfDay(this.tEndDate),
            isUserWorkAreaStartDateEndDate: 'true',
            userTimeZone: this.authService.getTimeZone(),
            patientBenefitType: this.selectedPatientBenefitType,
            duplicate: false
        };
        if (this.sortField && this.sortDirection) {
            params.sort = `${this.sortField},${this.sortDirection}`;
        }

    if (this.lastUsedFilterParams && Object.keys(this.lastUsedFilterParams).length > 0) {
      params = { ...params, ...this.lastUsedFilterParams };
    }
    // The selected domain takes precedence over any previous saved request.
    params.patientBenefitType = this.selectedPatientBenefitType;

    let filterType = type !== undefined ? type : this.selectedType;

    if (filterType === 1) {
      params.isUserWorkArea = true;
      if (this.searchString) {
        params.searchString = this.searchString;
        params.clientId = 1;
      }
    } else if (filterType === 2) {
      params.isUserWorkArea = true;
      params.active = true;
    } else if (filterType === 3) {
      params.isUserWorkArea = true;
      params.active = false;
    }

    this.insuranceServices.getUserWorkArea(params).pipe(first()).subscribe(
      (response: any) => {
       /* this.ngZone.run(() => {
          if (response) {
            this.tableData = response.content || response || [];
            this.totalRecord = response?.totalElements || 0;
            this.totalPagesArray = Array.from(
              { length: response?.totalPages || 0 },
              (_, i) => i + 1
            );

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            setTimeout(() => {
              this.cdr.detectChanges();
            }, 0);
          } else {
            this.tableData = [];
            this.totalRecord = 0;
            this.totalPagesArray = [];
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || '',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });*/
        this.updateTable(response);
      },
      (error) => {
        this.tableData = [];
        this.totalRecord = 0;
        this.totalPagesArray = [];
        this.cdr.detectChanges();

        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error?.error?.message || '',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
}

  toggleDateFilter() {
    this.showDateFilter = !this.showDateFilter;
  }

  applyFilter(): void {

    /*
    * Prevent an incomplete date range.
    */
    if (
      (this.startDate && !this.endDate) ||
      (!this.startDate && this.endDate)
    ) {

      swal.fire({
        icon: 'warning',
        title: 'Select Date Range',
        text: 'Please select both start date and end date.',
        showConfirmButton: false,
        timer: 3000
      });

      return;
    }


    /*
    * Reset pagination whenever filters change.
    */
    this.pagination.currentPage = 0;
    this.pagination.page = 1;


    // Keep the benefit selection even when no date range is selected.
    this.lastUsedFilterParams = {
      patientBenefitType: this.selectedPatientBenefitType
    };
    if (this.startDate && this.endDate) {
      this.lastUsedFilterParams.startDate = this.formatStartOfDay(this.startDate);
      this.lastUsedFilterParams.endDate = this.formatEndOfDay(this.endDate);
    }
    sessionStorage.setItem(
      'lastUsedFilterParams',
      JSON.stringify(this.lastUsedFilterParams)
    );


    sessionStorage.setItem(
      'userWorkListPage',
      JSON.stringify(this.pagination)
    );


    /*
    * selectedType:
    *
    * 1 = All
    * 2 = Active
    * 3 = Inactive
    *
    * _fetchData() will also add the date range.
    */
    this._fetchData(this.selectedType);


    this.showDateFilter = false;
  }

  // Call this when interacting with bsDatepicker
  onDatepickerShown() {
    this.ignoreDocumentClick = true;
    setTimeout(() => this.ignoreDocumentClick = false, 500); // brief ignore window
  }

  resetFilter(): void {

    this.startDate = null;
    this.endDate = null;

    /*
    * Preserve the component's original default:
    * Active records.
    */
    this.selectedStatusFilter = 'active';
    this.selectedType = 2;
    this.selectedPatientBenefitType = 'BOTH';

    this.lastUsedFilterParams = {};

    sessionStorage.removeItem(
      'lastUsedFilterParams'
    );


    this.pagination.currentPage = 0;
    this.pagination.page = 1;

    sessionStorage.setItem(
      'userWorkListPage',
      JSON.stringify(this.pagination)
    );


    this.showDateFilter = false;

    this._fetchData(2);
  }

  get activeFilterCount(): number {

    let count = 0;

    /*
    * "All" is considered no status filter.
    */
    if (this.selectedStatusFilter !== 'all') {
      count++;
    }

    /*
    * Date range counts as one filter.
    */
    if (this.startDate && this.endDate) {
      count++;
    }
    if (this.selectedPatientBenefitType) {
      count++;
    }

    return count;
  }


  get isWorkListFilterApplied(): boolean {

    return this.activeFilterCount > 0;
  }  

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.ignoreDocumentClick) return;

    const clickedInsideDropdown = this.filterDropdown?.nativeElement.contains(event.target);
    const clickedButton = this.filterBtn?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedButton) {
      this.showDateFilter = false;
    }
  }

  changeDate(){

        const params = {
            startDate: this.formatStartOfDay(this.startDate),
            endDate: this.formatEndOfDay(this.endDate),
            page: 1,  // Ensure this.currentPage is updated
            size: this.pagination.size,
            clientId: this.authService.getClientId() ? this.authService.getClientId() : null,
            isUserWorkAreaStartDateEndDate: 'true',
            userTimeZone: this.authService.getTimeZone(),
            patientBenefitType: this.selectedPatientBenefitType,
            duplicate: false
        };

    this.lastUsedFilterParams = {
      startDate: params.startDate,
      endDate: params.endDate,
      patientBenefitType: this.selectedPatientBenefitType
    }; // Save the current filters

        sessionStorage.setItem('lastUsedFilterParams', JSON.stringify(this.lastUsedFilterParams));


    this.insuranceServices.filterDate(params).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.updateTable(response);
        }
      },
      (error) => {
        // Handle errors
        swal.fire({
          title: 'Error!',
          icon: 'error',
          text: error.error.message || 'Something went wrong!',
          showConfirmButton: false,
          timer: 5000
        });
      }
    );
  }

  get isDateFilterApplied(): boolean {
    return !!(this.startDate && this.endDate);
  }

  // Sort form frontend logic
  sortData(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction === '' ? null : sort.direction;
    if (sort.active === 'apptDate' || sort.active === 'apptTime' || sort.active === 'careerName') {
      this.sortTableLocally(sort);
    } else {
      // Fetch sorted data from the backend for other fields
      this._fetchData(1);
    }
  }
  // Function to sort the table locally for apptDate and apptTime
  private sortTableLocally(sort: Sort) {
    const isAsc = sort.direction === 'asc';

    this.tableData.sort((a: any, b: any) => {
      let valueA = a[sort.active];
      let valueB = b[sort.active];

      // Handle null or empty values
      if (!valueA) return 1;
      if (!valueB) return -1;

      // If sorting `apptDate`, ensure proper date sorting
      if (sort.active === 'apptDate') {
        return isAsc
            ? new Date(valueA).getTime() - new Date(valueB).getTime()
            : new Date(valueB).getTime() - new Date(valueA).getTime();
      }

      // If sorting `apptTime`, use string comparison (assuming HH:mm format)
      if (sort.active === 'apptTime') {
        return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      // Sorting for `carrierName`
      if (sort.active === 'careerName') {
        return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      return 0;
    });}

  logout() {
    // Clear session storage during logout
    sessionStorage.removeItem('userWorkListPage');
    this.authService.logout();
  }

  trackByPatientId(index: number, item: any): any {
    return item && item.id != null ? item.id : index;
  }

  trackByPage(index: number, page: number): number {
    return page != null ? page : index;
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
